import React, { useState } from 'react';
import aicteLogo from '../Assets/Aicte/aictelogo.png'; 
import bannerImage from '../Assets/Aicte/aictebanner.jpg'; 

const AicteFeedback = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 font-sans pb-12">
      {/* 1. Header Banner */}
      <div className="bg-[#1a3683] py-10 px-4 text-center text-white shadow-lg mb-10">
        <div className="mb-4">
          <img 
            src={aicteLogo} 
            alt="AICTE Logo" 
            className="h-24 md:h-32 w-auto mx-auto drop-shadow-md bg-white p-2 rounded-lg" 
          />
        </div>
        <h1 className="text-3xl md:text-5xl font-bold uppercase tracking-wider">
          AICTE Feedback Facility
        </h1>
        <p className="mt-3 text-sm md:text-lg italic font-light opacity-90 max-w-2xl mx-auto">
          Transparency and Governance details of Sri Jyothi Polytechnic, Kalavapamula
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        
        {/* 2. Split Section: Notice (Left) and Image (Right) */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12 items-start">
          
          {/* Left Side: Information Notice Box */}
          <div className="lg:col-span-2 bg-white border-l-8 border-[#1a3683] p-8 shadow-md rounded-r-xl h-full flex flex-col justify-center">
            <div className="flex items-start">
              <div className="text-blue-600 mr-4 mt-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Official Notification</h2>
                <p className="text-gray-700 text-xl leading-relaxed">
                  This is to inform all the faculty, staff, and students that the feedback facility is available in the 
                  <span className="font-semibold text-[#1a3683]"> AICTE web portal</span>. 
                </p>
                <p className="text-gray-600 mt-4 text-lg">
                  You may use the links provided below to access the specific feedback portal relevant to your role.
                </p>
              </div>
            </div>
          </div>

          {/* Right Side: Banner Image (Click to Zoom) */}
          <div className="bg-white p-4 rounded-2xl shadow-md border border-gray-100 flex flex-col items-center">
            <div className="flex items-center self-start mb-3 px-2">
               <span className="text-blue-600 text-xl mr-2">✦</span>
               <h2 className="text-sm font-bold text-gray-800 uppercase tracking-tight">AICTE Document / Banner</h2>
            </div>
            
            <div 
              className="relative group cursor-zoom-in w-full border-4 border-gray-50 rounded-lg overflow-hidden"
              onClick={() => setIsFullScreen(true)}
            >
              <img 
                src={bannerImage} 
                alt="AICTE Banner" 
                className="w-full h-auto transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                 <span className="bg-white/90 px-4 py-3 rounded-full text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">CLICK TO ENLARGE</span>
              </div>
            </div>
            <p className="mt-3 text-[10px] text-gray-400 uppercase font-medium">Click image for full screen view</p>
          </div>
        </div>

        {/* 3. Original Feedback Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Student Card */}
          <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col group">
            <div className="bg-blue-50 px-6 py-4 border-b border-gray-100 group-hover:bg-blue-100 transition-colors">
              <h2 className="text-xl font-bold text-blue-900">For Students</h2>
            </div>
            <div className="p-6 flex-grow">
              <p className="text-gray-600 mb-6">
                Share your feedback regarding the curriculum, teaching standards, and campus facilities directly with AICTE.
              </p>
              <a 
                href="https://www.aicte-india.org/feedback/students.php" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full px-5 py-3 text-white bg-[#1a3683] rounded-lg font-semibold hover:bg-blue-800 transition-colors"
              >
                Student Feedback Portal
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
              </a>
            </div>
          </div>

          {/* Faculty Card */}
          <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col group">
            <div className="bg-indigo-50 px-6 py-4 border-b border-gray-100 group-hover:bg-indigo-100 transition-colors">
              <h2 className="text-xl font-bold text-indigo-900">For Faculty & Staff</h2>
            </div>
            <div className="p-6 flex-grow">
              <p className="text-gray-600 mb-6">
                Professional feedback portal for faculty and staff to report concerns or suggestions regarding institutional governance.
              </p>
              <a 
                href="https://www.aicte-india.org/feedback/faculty.php" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full px-5 py-3 text-white bg-indigo-700 rounded-lg font-semibold hover:bg-indigo-800 transition-colors"
              >
                Faculty Feedback Portal
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
              </a>
            </div>
          </div>
        </div>

        {/* 4. Footer Link */}
        <div className="mt-12 text-center bg-gray-100 p-6 rounded-lg border border-dashed border-gray-400">
          <p className="text-gray-600 mb-2 font-medium">Main Feedback Web Portal</p>
          <a 
            href="https://www.aicte-india.org/feedback/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#1a3683] font-bold text-lg underline hover:text-blue-800"
          >
            https://www.aicte-india.org/feedback/
          </a>
        </div>
      </div>

      {/* Full Screen Modal */}
      {isFullScreen && (
        <div 
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 animate-in fade-in duration-300"
          onClick={() => setIsFullScreen(false)}
        >
          <button className="absolute top-6 right-6 text-white text-5xl hover:text-red-500 transition-colors">&times;</button>
          <img 
            src={bannerImage} 
            alt="Full Banner" 
            className="max-w-full max-h-full object-contain shadow-2xl"
          />
        </div>
      )}
    </div>
  );
};

export default AicteFeedback;